// 🔒 PROTECTED — PricePAL Compare
// Owner: Garry Yee | Do not modify without explicit written permission
// See /app/PROTECTED_CODE_REGISTRY.md for full rules
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * AI Chat Widget - PLACEHOLDER MODE
 * 
 * Future Integration: AI Staff chat service
 * Current: Display contact information
 */
const AIChatWidget = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Chat Icon Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-3xl transition-all transform hover:scale-110 flex items-center space-x-2"
          aria-label="Open chat"
        >
          {isOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
              <span className="font-semibold hidden md:block">Help</span>
            </>
          )}
        </button>
      </div>

      {/* Chat Window */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 w-80 md:w-96 bg-white rounded-2xl shadow-2xl z-50 border border-gray-200 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-green-600 text-white p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-blue-600 font-bold text-lg">
                  P
                </div>
                <div>
                  <h3 className="font-bold">PricePAL Compare Support</h3>
                  <p className="text-xs text-blue-100">We're here to help</p>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-1 transition"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          {/* Chat Content - Placeholder */}
          <div className="p-6 space-y-4 bg-gray-50">
            {/* Bot Message */}
            <div className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-green-600 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                P
              </div>
              <div className="bg-white rounded-lg rounded-tl-none p-4 shadow-sm max-w-[85%]">
                <p className="text-gray-700 mb-3">
                  <strong className="text-gray-900">Welcome to PricePAL Compare!</strong> 👋
                </p>
                <p className="text-sm text-gray-600 mb-3">
                  Our AI chat service is coming soon. In the meantime, we're here to help through:
                </p>
                <div className="space-y-2 text-sm">
                  <a 
                    href="mailto:support@pricepalcompare.com"
                    className="flex items-center space-x-2 text-blue-600 hover:text-blue-800 font-semibold"
                  >
                    <span>📧</span>
                    <span>support@pricepalcompare.com</span>
                  </a>
                  <a 
                    href="tel:08001234567"
                    className="flex items-center space-x-2 text-blue-600 hover:text-blue-800 font-semibold"
                  >
                    <span>📞</span>
                    <span>0800 123 4567</span>
                  </a>
                </div>
                <p className="text-xs text-gray-500 mt-3">
                  Response time: Within 24 hours
                </p>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="space-y-2">
              <p className="text-xs font-semibold text-gray-500 uppercase">Quick Links</p>
              <button
                onClick={() => navigate('/how-it-works')}
                className="w-full text-left px-4 py-3 bg-white hover:bg-gray-50 rounded-lg border border-gray-200 transition text-sm font-semibold text-gray-700"
              >
                📖 How It Works
              </button>
              <button
                onClick={() => navigate('/pricing')}
                className="w-full text-left px-4 py-3 bg-white hover:bg-gray-50 rounded-lg border border-gray-200 transition text-sm font-semibold text-gray-700"
              >
                💰 Pricing Plans
              </button>
              <button
                onClick={() => navigate('/contact')}
                className="w-full text-left px-4 py-3 bg-white hover:bg-gray-50 rounded-lg border border-gray-200 transition text-sm font-semibold text-gray-700"
              >
                ✉️ Contact Us
              </button>
            </div>
          </div>

          {/* Footer Notice */}
          <div className="p-3 bg-blue-50 border-t border-blue-100">
            <p className="text-xs text-gray-600 text-center">
              🤖 <strong>AI Chat powered by AI Staff</strong> - Coming Soon
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default AIChatWidget;
